// Dil ayarları. Türkçe varsayılan dildir ve kök adreslerde yayınlanır (/hakkimizda); İngilizce /en altındadır.
// Uygulama içinde tüm sayfalar app/[lang] altında durur; dış adres ↔ iç yol eşlemesi: ./routes.ts, src/proxy.ts

export const locales = ["tr", "en"] as const;
export type Locale = (typeof locales)[number];
export const defaultLocale: Locale = "tr";

export function hasLocale(value: string | undefined | null): value is Locale {
  return value === "tr" || value === "en";
}

export const localeMeta: Record<Locale, { htmlLang: string; intl: string; ogLocale: string; label: string; short: string }> = {
  tr: { htmlLang: "tr", intl: "tr-TR", ogLocale: "tr_TR", label: "Türkçe", short: "TR" },
  en: { htmlLang: "en", intl: "en-GB", ogLocale: "en_GB", label: "English", short: "EN" },
};

/** "{n} tur" gibi şablonları doldurur. Bilinmeyen yer tutucu olduğu gibi kalır. */
export function fmt(template: string, vars: Record<string, string | number> = {}): string {
  return template.replace(/\{(\w+)\}/g, (m, key: string) => (key in vars ? String(vars[key]) : m));
}

/** Tekil/çoğul: İngilizce için "1 tour" / "2 tours"; Türkçede iki şablon aynıdır. */
export function plural(n: number, forms: { one: string; other: string }): string {
  return fmt(n === 1 ? forms.one : forms.other, { n });
}
